import { render, staticRenderFns } from "./Live.vue?vue&type=template&id=0b8d664a&scoped=true"
import script from "./Live.vue?vue&type=script&lang=js"
export * from "./Live.vue?vue&type=script&lang=js"
import style0 from "./Live.vue?vue&type=style&index=0&id=0b8d664a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8d664a",
  null
  
)

export default component.exports